import classNames from "classnames";
import React from "react";

function List({ className, children }) {
  return (
    <ul className={classNames("custom-list", { [className]: !!className })}>
      {children}
    </ul>
  );
}

List.Item = ({ title, value }) => (
  <li className="custom-list__item">
    <span className="custom-list__title">{title}</span>
    {value && <span className="custom-list__value">{value}</span>}
  </li>
);

export default List;
